import { Property } from '../../types/property';

export interface PropertyTour {
  url: string;
  tourIndex?: number;
  insecure: boolean;
}

const getPropertyTour = (property: Property): PropertyTour | null => {
  if (property['360Tours']) {
    const index = property['360Tours']?.findIndex((tour) => tour.type !== 'video');

    if (index >= 0) {
      return {
        url: property['360Tours'][index].url,
        tourIndex: index,
        insecure: property['360Tours'][index].insecure,
      };
    }
  } else if (property.virtualTour && property.virtualTour.type !== 'video') {
    return {
      url: property.virtualTour.url,
      tourIndex: 0,
      insecure: property.virtualTour.insecure,
    };
  }

  return null;
};

export default getPropertyTour;
